import * as React from 'react';
import {
  List,
  ListItem,
  ListItemTitle,
  ListItemText
} from '../../../Components';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ListItemActions } from '../../../Components/List/ListItemActions';
import { OrientacaoModel } from '../../../Store/Chat';
import { Tag } from '../../../Components/Tag/Tag';
import { format } from 'date-fns';
import { apiState } from '../../../Api';

/*
  interfaces
*/
interface IProps {
  orientacoes: OrientacaoModel[];
  loadState: apiState;
}

/*
  styled components
*/
const StyledItem = styled(ListItem)`
  display: flex;
`;

/*
  component: ConvitesList
*/
@observer
export class OrientacaoList extends React.Component<IProps> {

  render() {
    const { orientacoes, loadState } = this.props;

    return (
      <>
      <List showBorder={false}>
        {orientacoes &&
          orientacoes.map((o, i) => (
            o.aluno.alunoAtivo &&
            <>
              <StyledItem
                key={i}
                onClick={() => {
                  window.location.pathname = `professor/orientacoes/${o.aluno.id}`;
                }}
              >
                <ListItemTitle> {o.aluno.nome} </ListItemTitle>
                <ListItemText>{o.ultimaMensagem ? `[${format(o.ultimaMensagem.enviadoEm, 'DD/MM/YYYY HH:mm')}]: ${o.ultimaMensagem.texto}` : "Não há novas orientações"}</ListItemText>
                <ListItemActions>{
                  o.ultimaMensagem &&
                  <Tag color={'primaryColor'}>{o.mensagensPendentes >= 1 ? (o.mensagensPendentes === 1 ? "Há uma nova solicitação" : `Há ${o.mensagensPendentes} novas solicitações`) : "Não há novas mensagens"}</Tag>
                }</ListItemActions>
              </StyledItem>
            </>
          ))}
      </List>
      {loadState === apiState.loading && <div style={{
          height: '30px',
          fontSize: '1.2em',
          margin: '15px',
          marginLeft: '26px',
          color: 'grey'
        }}>Carregando novas orientações...</div>}
      </>
    );
  }
}
